import React from 'react';
import cn from 'clsx';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import { TLeadScore } from 'crono-fe-common/types/leadScore';
import { ScoreSettingsTypes } from 'crono-fe-common/types/DTO/patchScoringSettings';
import {
  getColorsByScoreRange,
  getIconByScoreChange,
  getScoreChange,
  getScoreRange,
} from '../lead-score.constants';

export interface ILeadScoreBadgeProps {
  mdScore: number;
  highScore: number;
  size?: 'xs' | 'sm' | 'md';
  iconSize?: 'xs' | 'sm' | 'md';
  details: TLeadScore['score'];
  type: ScoreSettingsTypes;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  TooltipComponent?: React.ComponentType<TooltipProps>;
}

export const LeadScoreBadge = ({
  details,
  mdScore,
  highScore,
  size = 'md',
  iconSize = 'sm',
  open,
  onOpenChange,
  TooltipComponent = Tooltip,
}: ILeadScoreBadgeProps) => {
  const currentScore = details?.currentScore;
  const previousScore = details?.lastScore;

  const scoreRange = getScoreRange(currentScore, mdScore, highScore);
  const scoreColors = getColorsByScoreRange(scoreRange);
  const scoreChange = getScoreChange(previousScore, currentScore);
  const scoreChangeIcon = getIconByScoreChange(scoreChange, iconSize);

  const TooltipTag = TooltipComponent ?? Tooltip;

  const getSize = () => {
    return {
      xs: {
        label: 'text-3xs',
        wrapper: 'w-[32px] h-[14px]',
      },
      sm: {
        label: 'text-[12px]',
        wrapper: 'w-[40px] h-[20px]',
      },
      md: {
        label: 'text-[14px]',
        wrapper: 'w-[52px] h-[28px]',
      },
    }[size];
  };

  return (
    <div>
      <TooltipTag
        title="Click to view details"
        enterDelay={400}
        enterNextDelay={400}
        placement="top"
      >
        <button
          className={cn(
            'flex items-center justify-center border border-solid rounded-2xl cursor-pointer bg-white outline-none',
            scoreColors.text,
            scoreColors.border,
            getSize().wrapper,
          )}
          onClick={(e) => {
            e.stopPropagation();
            onOpenChange(!open);
          }}
          type="button"
        >
          {scoreChangeIcon && (
            <div className="flex items-center justify-center">
              {scoreChangeIcon}
            </div>
          )}

          <div className={cn('font-medium', getSize().label)}>
            {currentScore ?? '-'}
          </div>
        </button>
      </TooltipTag>
    </div>
  );
};
